import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TeamManagementComponent} from './team-management.component';
import {TeamManagementRoutingModule} from './team-management-routing.module';
import {SharedModule} from '../../shared/shared.module';
import { TeamCardComponent } from './team-card/team-card.component';
import {DragDropModule} from '@angular/cdk/drag-drop';
import { TeamDialogComponent } from './team-dialog/team-dialog.component';
import { TranslateModule } from '@ngx-translate/core';


@NgModule({
    declarations: [TeamManagementComponent, TeamCardComponent, TeamDialogComponent],
    imports: [
        CommonModule,
        SharedModule,
        TeamManagementRoutingModule,
        DragDropModule,
        TranslateModule
    ],
    exports: [TranslateModule]
})
export class TeamManagementModule {
}
